import React , { useState,useContext, useEffect } from 'react'
import { Link ,useNavigate } from "react-router-dom";
import $ from 'jquery';
import {toast} from 'react-toastify'
import { global } from '../../Context/Context';
import axiosInstance from '../../config/axiosInterceptor';

// `imageField` is the column holding the still preview image: Frames and
// EntryEffects keep theirs in `thumbnail`, the other four in `image`. Rendering
// `item.image` for all six left the Frame and Entry Effect rows blank.
const itemTypes = [
    { key: 'frames', label: 'Frame', imageField: 'thumbnail', addPath: '/admin/addFrames', editPath: '/admin/editFrames', deleteUrl: 'frame/deleteframes' },
    { key: 'entryEffects', label: 'Entry Effect', imageField: 'thumbnail', addPath: '/admin/addEntryEffect', editPath: '/admin/editEntryEffect', deleteUrl: 'entryeffects/deleteentryeffects' },
    { key: 'bubbles', label: 'Bubble', imageField: 'image', addPath: '/admin/addBubbles', editPath: '/admin/editBubbles', deleteUrl: 'bubbles/deletebubbles' },
    { key: 'profileBadge', label: 'Profile Badge', imageField: 'image', addPath: '/admin/addProfileBadge', editPath: '/admin/editProfileBadge', deleteUrl: 'profileBadge/deleteprofilebadge' },
    { key: 'userBadge', label: 'User Badge', imageField: 'image', addPath: '/admin/addUserBadge', editPath: '/admin/editUserBadge', deleteUrl: 'userBadge/deleteuserbadge' },
    { key: 'namePlate', label: 'Name Plate', imageField: 'image', addPath: '/admin/addNamePlate', editPath: '/admin/editNamePlate', deleteUrl: 'namePlate/deletenameplate' },
];

const ViewVip = () => {

    const { viewVipAllItems, viewVipAllItemsS } = useContext(global)
    const [ de , setDe ] = useState(0);
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const userId = params.get('id');

    useEffect(() => {
        const queryString = window.location.search;
        const params = new URLSearchParams(queryString);
        const userId = params.get('id');

        viewVipAllItems(userId);
    }, [de]);

    // How many items of one type this Vip already has. Used both to blur the
    // Add button and to render each type's table, so the two cannot disagree.
    const itemCount = (key) =>
        Array.isArray(viewVipAllItemsS[key]) ? viewVipAllItemsS[key].length : 0;

    const handleDeleteItem = async (deleteUrl, id)=>{
        await axiosInstance.delete(`${process.env.REACT_APP_BASEURL5}/admin/${deleteUrl}/${id}`).then((res)=>{
            if(res.data.success===1){
                        toast.success(res.data.message)
                        setDe(de+1);
                    }else{
                        toast.error(res.data.message)
                    }
        }).catch((e)=>{
            toast.error(e.message);
        });
    }

    return (
        <>
            {/* Content Header (Page header) */}
            <section className="content-header">
                <h1>Manage Vip Package </h1>
                <ol className="breadcrumb">
                    <li><Link to="/admin"><i className="fa fa-dashboard"></i> Home</Link></li>
                    <li className="active">Manage Vip Package </li>
                </ol>
            </section>
            {/* Main content */}
            <section className="content">
                <div className="row">
                    <div className="col-xs-12">
                        {/* /.box */}
                        <div className="box">
                            {/* /.box-header */}
                            <div className="box-body">
                                <div className="box-header">
                                    {itemTypes.map((t) => {
                                        // A VIP grants exactly one item per type, so once one is
                                        // linked there is nothing to add - disable the button rather
                                        // than let a second item be created and silently ignored.
                                        const already = itemCount(t.key) > 0;
                                        return (
                                            <h3 className="box-title" key={t.key} style={{ marginRight: '8px', display: 'inline-block' }}>
                                                {already ? (
                                                    <span
                                                        className="btn btn-block btn-success btn-xs disabled"
                                                        style={{ fontSize: '14px', opacity: 0.45, cursor: 'not-allowed' }}
                                                        title={`This Vip already has a ${t.label}. Edit or delete it below to change it.`}
                                                    >
                                                        Add {t.label}
                                                    </span>
                                                ) : (
                                                    <Link to={`${t.addPath}?vipId=${userId}`} style={{ fontSize: '14px' }} className="btn btn-block btn-success btn-xs">Add {t.label}</Link>
                                                )}
                                            </h3>
                                        );
                                    })}
                                    <h3 className="box-title" style={{float:'right'}}><Link to={`/admin/manageVip`} style={{ fontSize: '14px' }} className="btn btn-block btn-success btn-xs">Go Back</Link></h3>
                                </div>
                                {itemTypes.map((t) => {
                                    const items = Array.isArray(viewVipAllItemsS[t.key]) ? viewVipAllItemsS[t.key] : [];
                                    const extra = items.length > 1;
                                    return (
                                        <div key={t.key} style={{ marginBottom: '24px' }}>
                                            <h4>{t.label}</h4>
                                            {extra && (
                                                <p style={{ color: '#c0392b', marginBottom: '6px' }}>
                                                    <i className="fa fa-warning" /> This Vip has {items.length} {t.label}s
                                                    linked, but only one is granted to users. Delete the extras.
                                                </p>
                                            )}
                                            <table id="example1" className="table table-bordered table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>Sr.</th>
                                                        <th>Image</th>
                                                        <th>Title</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {items.length === 0 && (
                                                        <tr>
                                                            <td colSpan="4">No {t.label} linked to this Vip</td>
                                                        </tr>
                                                    )}
                                                    {items.map((item, index) => {
                                                        let i = index + 1;
                                                        return (
                                                            <tr key={item._id}>
                                                                <td>{i}</td>
                                                                <td>
                                                                    {item[t.imageField] || item.image || item.thumbnail ? (
                                                                        <img
                                                                            src={item[t.imageField] || item.image || item.thumbnail}
                                                                            width={"80px"}
                                                                            alt={t.label}
                                                                        />
                                                                    ) : (
                                                                        <span className="text-muted">no image</span>
                                                                    )}
                                                                </td>
                                                                <td>{item.title}</td>
                                                                <td>
                                                                    <ul className="admin-action btn btn-default" style={{ backgroundColor: '#f4f4f4', color: '#fff !important' }}>
                                                                        <li className="dropdown">
                                                                            <a className="dropdown-toggle" style={{ color: 'black' }} data-toggle="dropdown" href="#" aria-expanded="false">
                                                                                Action
                                                                            </a>
                                                                            <ul className="dropdown-menu dropdown-menu-right">
                                                                                <li role="presentation">
                                                                                    <Link role="menuitem" tabIndex={-1} to={`${t.editPath}?id=${item._id}`}>Edit</Link>
                                                                                </li>
                                                                                <li role="presentation">
                                                                                    <Link role="menuitem" tabIndex={-1} onClick={()=>{
                                                                                        const confirmDelete = window.confirm("Are you sure you want to delete this item?");
                                                                                        if (confirmDelete) {
                                                                                            handleDeleteItem(t.deleteUrl, item._id);
                                                                                        }
                                                                                    }}>Delete</Link>
                                                                                </li>
                                                                            </ul>
                                                                        </li>
                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    );
                                })}
                            </div>
                            {/* /.box-body */}
                        </div>
                        {/* /.box */}
                    </div>
                    {/* /.col */}
                </div>
                {/* /.row */}
            </section>
            {/* /.content */}
        </>
    )
}

export default ViewVip